import React, {Fragment, useState} from 'react';
import {Section, Explanation_text} from '../../../components';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PersonIcon from '@material-ui/icons/Person';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import User_popup from './User_popups';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import CancelIcon from '@material-ui/icons/Cancel';
import FiberNewIcon from '@material-ui/icons/FiberNew';

export default function User_section(props){
  const[update_user_popup, setUpdateUserPopup]=useState(false);
  const[delete_user_popup, setDeleteUserPopup]=useState(false);
  let uw=(props.user_id==undefined || props.workspace==undefined)?undefined:props.workspace.all_user_workspaces[props.user_id];
  let date_time=null; if(uw!=undefined){date_time=(uw.new==true)?uw.updated_at:uw.created_at;
    date_time=date_time.split('T')[0]+' '+date_time.split('T')[1];
    date_time=date_time.split('.')[0];
  }
  return(
    <Fragment>
      <div style={{marginTop:'130px'}}/>
      {(uw==undefined)?null:
      <Section maxWidth='600px' icon={(uw.user_id==null && uw.user_id==undefined)?<CancelIcon color='secondary'/>:(uw.new==true)?<FiberNewIcon color='secondary'/>:(uw.admin==true)?<SupervisorAccountIcon color='primary'/>:<PersonIcon color='primary'/>} title={uw.first_name+' '+uw.last_name} action={(props.me.user_workspace_id==props.user_id || (uw.admin==true && props.workspace.user_id!=props.me.id))?undefined:<span><EditIcon color='primary' style={{cursor:'pointer', marginRight:'10px'}} onClick={()=>{setUpdateUserPopup(true);}}/>{(uw.user_id==undefined)?null:<DeleteIcon color='secondary' style={{cursor:'pointer'}} onClick={()=>{setDeleteUserPopup(true);}}/>}</span>}>
        {(uw==undefined)?null:
          <Fragment>
            <Input_option title='team_setup_role_label' value={(uw.user_id==props.workspace.user_id)?'Owner':(uw.admin==true)?'Admin':'Basic'}/>
            <Input_option title='team_setup_email_label' value={uw.email}/>
            <Input_option title={(uw.new==true)?'team_setup_invited_on_label':'team_setup_joined_on_label'} value={date_time}/>
          </Fragment>
        }
      </Section>
      }
      {(update_user_popup==true)?<User_popup {...props} initialValues={uw} handleClose={()=>{setUpdateUserPopup(false);}}/>:null}
      {(delete_user_popup==true)?<User_popup {...props} delete uw={uw} handleClose={()=>{setDeleteUserPopup(false);}}/>:null}
    </Fragment>
  )
}




function Input_option(props){return(<Typography variant='caption'><Grid container><Grid item xs={6} sm={3} style={{fontWeight:'bold'}}><Explanation_text style='bold_caption' text={props.title}/>:</Grid><Grid item xs={6} sm={9}>{props.value}</Grid></Grid></Typography>)}
